import React from "react"
import { Navigate } from "react-router-dom"

// Dashboard
import Home from "../pages/Dashboard/home"
import ApplicationsList from "../pages/Dashboard/application"


//Pages
import Pages404 from "../pages/Utility/pages-404"

import Logout from "../pages/Authentication/Logout"
import DynamicModule from "../pages/DynamicModule"
import Singup from "../pages/Authentication/Singup"
import FormTest from "../components/Lystface/FormTest"
import Login from "../pages/Authentication/Login"
import ForgotPassword from "../pages/Authentication/ForgotPassword"
import NewPassword from "../pages/Authentication/NewPassword"
import VerfiedPage from "../pages/Authentication/VerfiedPage"
import BillingDetails from "../pages/Settings/Billing details/index"
import Application from "../pages/Dashboard/application/Application"
import AccountSetting from "../pages/Settings/AccountSetting";
import Usage from "../pages/Usage"
import SignupSuccess from "../pages/Authentication/SignupSuccess"
import VerificationSuccess from "../pages/Settings/Billing details/VerificationSuccess"
import Pricing from "../pages/Settings/Pricing"
// import Pricing from "../pages/Settings/Pricing"


const userRoutes = [
  { path: "/dashboard", component: <Home /> },
  { path: "/verification/success", component: <VerificationSuccess /> },
  { path: "/application", component: <ApplicationsList /> },
  { path: "/usage", component: <Usage /> },
  { path: "/application/:appId", component: <Application applicationStatus={"manage"} /> },
  { path: "/application/add-application", component: <Application applicationStatus={"create"} /> },
  { path: "/dynamic-module/:moduleName", component: <DynamicModule /> },
  { path: "/settings/billing-details/setup", component: <BillingDetails /> },
  { path: "/settings/billing-details", component: <BillingDetails /> },
  { path: "/settings/account-setting", component: <AccountSetting /> },
  { path: "/settings/pricing", component: <Pricing /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/signup", component: <Singup /> },
  { path: "/signup/success", component: <SignupSuccess /> },
  { path: "/login", component: <Login /> },
  // { path: "/form-test", component: <FormTest /> },

  // { path: "/login", component: <Login /> },
  // { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/verify-email/:emailId", component: <VerfiedPage /> },
  { path: "/forgot-password/:passId", component: <NewPassword /> },
  // { path: "/register", component: <Register /> },

  { path: "/pages-404", component: <Pages404 /> },
]

export { userRoutes, authRoutes }
